import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from 'react-apollo';
import set from 'lodash/set';
import get from 'lodash/get';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import Spin from 'components/common/Spin';
import { GET_SETTINGS, SAVE_SETTINGS } from 'graphql/settings';
import useSnack from 'hooks/useSnack';



const useStyles = makeStyles((theme) => ({
  input: {
    '& input': {
      padding: 8,
    },
  },
}));



const Row = ({ name, label, days, value, onChange }) => {
  const classes = useStyles();

  const handleChange = (e) => {
    const { target } = e;
    onChange({
      target: {
        name,
        value: {
          ...value,
          [target.name]: +target.value
        }
      }
    });
  }

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item md={8}>
        <Typography>{label}</Typography>
      </Grid>
      {days !== false && (
        <Grid item md={2}>
          <Input
            disableMargin
            name="days"
            className={classes.input}
            type="number"
            value={get(value, 'days')}
            onChange={handleChange}
          />
        </Grid>
      )}
      <Grid item md={2}>
        <Input
          disableMargin
          name="points"
          className={classes.input}
          type="number"
          value={get(value, 'points')}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};


const Settings = ({ setColors, onClose }) => {
  const snack = useSnack();
  const { data, loading } = useQuery(GET_SETTINGS, {
    variables: { key: 'ENGAGEMENT_CONFIG' },
    fetchPolicy: 'cache-and-network',
    onCompleted: (val) => {
      if (val) {
        const { value } = val.settings;
        setValues(value);
      }
    },
  });
  const [updateSettings] = useMutation(SAVE_SETTINGS, {
    variables: { key: 'ENGAGEMENT_CONFIG' },
  });
  const [values, setValues] = useState({
    last_student_activity: {
      days: '',
      points: ''
    },
    text_send_by_student: {
      days: '',
      points: ''
    },
    chat_send_by_student: {
      days: '',
      points: ''
    },
    no_pending_message_response: {
      points: '',
      days: '',
    },
    no_pending_essay_review: {
      points: '',
      days: '',
    },
    last_milestone_meeting_done: {
      days: '',
      points: ''
    },
    last_coaching_meeting_done: {
      days: '',
      points: ''
    },
    next_milestone_meeting: {
      days: '',
      points: ''
    },
    next_coaching_meeting: {
      days: '',
      points: ''
    },
    min_high_score: '',
    min_mid_score: '',
    min_low_score: '',
  });



  const onChange = (e) => {
    const { name, value } = e.target;
    values[name] = value;
    setValues({ ...values });
  };

  const updateMinValues = () => {

    if (values.min_high_score === '' || values.min_low_score === '' || values.min_mid_score === '') {

    } else {
      const mins = {
        high: parseInt(values?.min_high_score),
        mid: parseInt(values?.min_mid_score),
        low: parseInt(values?.min_low_score),
      }
      setColors(mins)
    }
  }


  const onSave = () => {
    updateMinValues();
    return updateSettings({
      variables: {
        value: values
      }
    }).then(
      () => snack.success('Settings saved'),
      onClose(),
      (e) => snack.error(e.message)
    )
  };

  return (
    <Drawer open anchor="right">
      {loading ? (
        <Spin spinning />
      ) : (
        <Box width={500} p={2}>
          <Typography variant="h4">Settings</Typography>
          <Box mt={3}>
            <Typography variant="subtitle2" paragraph>
              Scores
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item md={8}>
                Trigger
              </Grid>
              <Grid item md={2}>
                Days
              </Grid>
              <Grid item md={2}>
                Point
              </Grid>
            </Grid>
            <Row
              name="last_student_activity"
              label="Last activity within"
              value={values.last_student_activity}
              onChange={onChange}
            />
            <Row
              name="text_send_by_student"
              label="Student sent text within"
              value={values.text_send_by_student}
              onChange={onChange}
            />
            <Row
              name="chat_send_by_student"
              label="Student sent chat within"
              value={values.chat_send_by_student}
              onChange={onChange}
            />
            <Row
              name="no_pending_message_response"
              label="No Pending chat/text message"
              value={values.no_pending_message_response}
              onChange={onChange}
            />
            <Row
              name="no_pending_essay_review"
              label="No pending essay review"
              value={values.no_pending_essay_review}
              onChange={onChange}
            />
            <Row
              name="last_milestone_meeting_done"
              label="Last milestone meeting was completed within"
              value={values.last_milestone_meeting_done}
              onChange={onChange}
            />
            <Row
              name="last_coaching_meeting_done"
              label="Last coaching session was completed within"
              value={values.last_coaching_meeting_done}
              onChange={onChange}
            />
            <Row
              name="next_milestone_meeting"
              label="Next milestone meeting scheduled in next"
              value={values.next_milestone_meeting}
              onChange={onChange}
            />
            <Row
              name="next_coaching_meeting"
              label="Next coaching session scheduled in next"
              value={values.next_coaching_meeting}
              onChange={onChange}
            />
          </Box>
          <Box mt={4}>
            <Typography variant="subtitle2" paragraph>
              Minimum score
            </Typography>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <Input
                  name="min_high_score"
                  value={values.min_high_score}
                  onChange={onChange}
                  label="Green"
                  type="number"
                />
              </Grid>
              <Grid item md={4}>
                <Input
                  name="min_mid_score"
                  value={values.min_mid_score}
                  onChange={onChange}
                  label="Yellow"
                  type="number"
                />
              </Grid>
              <Grid item md={4}>
                <Input
                  name="min_low_score"
                  value={values.min_low_score}
                  onChange={onChange}
                  label="Red"
                  type="number"
                />
              </Grid>
            </Grid>
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={3}>
            <Button onClick={onClose}>Close</Button>{' '}
            <Button variant="contained" color="primary" onClick={onSave}>
              Save
            </Button>
          </Box>
        </Box>
      )}
    </Drawer>
  );
};

export default Settings;
